import styled from '@emotion/styled';
import { bodyM, subTitle2, tag1M, tag2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-self: flex-start;
`;

export const Title = styled.div`
  ${subTitle2};
  color: ${vars.neutral[80]};
  text-align: left;

  ${DESKTOP} {
    ${subTitle2};
    color: ${vars.neutral[90]};
  }
`;

export const Info = styled.div`
  ${bodyM}
  color: ${vars.neutral[80]};
  text-align: left;

  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[80]};
  }
`;

export const Description = styled.div`
  color: ${vars.neutral[60]} !important;
  ${tag2};

  ${DESKTOP} {
    ${tag1M};
  }
`;

export const ImageContainer = styled.div`
  margin: 0 auto;
`;

export const ImageWrapper = styled.div`
  position: relative;
  object-fit: cover;
  width: 240px;
  height: 140px;
  margin: 0 auto;
`;
